import "./Landing.css";
import { FaLinkedin, FaGithub } from "react-icons/fa";
import { IconButton, useTheme, Button } from "@chakra-ui/react";
import developerGirl from "../../assets/developerGirl.svg";
import resume from "../../assets/resume.pdf";

const Landing = () => {
    const theme = useTheme();
    return (
        <div
            className="landing"
            style={{
                color: theme.colors.secondary,
            }}
        >
            <div className="landingContainer">
                <div className="leftContainer">
                    <div className="landingHeadings">
                        <h1>Anna Munro</h1>
                        <h2>Frontend Developer</h2>
                    </div>
                    <div className="resumeContainer">
                        <a
                            href={resume}
                            download="resume"
                            target="_blank"
                            rel="noreferrer"
                            className="resumeButton"
                        >
                            <Button
                                style={{
                                    color: "white",
                                    backgroundColor: theme.colors.tertiary,
                                }}
                            >
                                Download CV
                            </Button>
                        </a>
                    </div>
                    <div className="socialContent">
                        <a
                            href="https://linkedin.com/in/anna-frances-munro/"
                            target="_blank"
                            rel="noreferrer"
                        >
                            <IconButton
                                colorScheme="primary"
                                fontSize="3rem"
                                aria-label="LinkedIn"
                                icon={<FaLinkedin />}
                                className="landingSocialIcon"
                            />
                        </a>
                        <a
                            href="https://github.com/annafran"
                            target="_blank"
                            rel="noreferrer"
                        >
                            <IconButton
                                colorScheme="primary"
                                fontSize="3rem"
                                aria-label="GitHub"
                                icon={<FaGithub />}
                                className="landingSocialIcon"
                            />
                        </a>
                    </div>
                </div>
                <div className="rightContainer">
                    <img
                        className="landingImage"
                        src={developerGirl}
                        alt="developer girl"
                    />
                </div>
            </div>
        </div>
    );
};

export default Landing;
